module.exports = __webpack_public_path__ + "assets/img/landing-hero.91feea29.jpg";